import { PlusIcon } from "@phosphor-icons/react";
import { Button, DropdownMenu, Flex, Text } from "@radix-ui/themes";

export interface WatchlistSetupPresentationProps {
  lists: ReadonlyArray<{ id: string; name: string }>;
  isLoading: boolean;
  isDisabled: boolean;
  onSelectExisting: (watchlistId: string) => void;
  onCreate: () => void;
}

/**
 * Unbound empty-state: no watchlist selected yet. Counts are intentionally
 * omitted — the connector's list payload doesn't include `assets`, and
 * rendering one would mean an extra fetch per list.
 */
export const WatchlistSetupPresentation = ({
  lists,
  isLoading,
  isDisabled,
  onSelectExisting,
  onCreate,
}: WatchlistSetupPresentationProps) => {
  const triggerDisabled = isLoading || isDisabled;
  const triggerLabel = triggerDisabled
    ? "Loading watch lists…"
    : "Set up watch list";
  const namedLists = lists.filter((list) => list.name.trim().length > 0);

  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      gap="3"
      p="5"
      height="100%"
    >
      <Flex direction="column" align="center" gap="1">
        <Text size="3" weight="bold" align="center">
          Set up your watch list
        </Text>
        <Text size="1" color="gray" align="center">
          Choose an existing list or start a new one.
        </Text>
      </Flex>
      <DropdownMenu.Root>
        <DropdownMenu.Trigger>
          <Button disabled={triggerDisabled}>
            <PlusIcon size={16} weight="bold" />
            <Text>{triggerLabel}</Text>
            <DropdownMenu.TriggerIcon />
          </Button>
        </DropdownMenu.Trigger>
        <DropdownMenu.Content size="2" align="center">
          <DropdownMenu.Label>
            <Text>Your watch lists</Text>
          </DropdownMenu.Label>
          {namedLists.map((list) => (
            <DropdownMenu.Item
              key={list.id}
              onSelect={() => onSelectExisting(list.id)}
            >
              <Text>{list.name}</Text>
            </DropdownMenu.Item>
          ))}
          <DropdownMenu.Separator />
          <DropdownMenu.Item onSelect={() => onCreate()}>
            <PlusIcon size={14} />
            <Text>Create new watchlist</Text>
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Root>
    </Flex>
  );
};
